export default __webpack_public_path__ + "static/media/0-0.47aae2d1.png";